// extracted by mini-css-extract-plugin
export var locationCard = "_ox-0";